import "./Header.css";

type HeaderProps = {
  img: string;
  label: string;
  storeUrl: string;
  hideDownloadBadge?: boolean;
  app?: "shoplist" | "stackclash";
};

const Header = ({
  img,
  label,
  storeUrl,
  hideDownloadBadge = false,
  app = "shoplist",
}: HeaderProps) => {
  const iconClass =
    app === "stackclash"
      ? "Header-app-icon Header-app-icon--stackclash"
      : "Header-app-icon Header-app-icon--shoplist";

  return (
    <header className="Header">
      <div className="Header-left">
        <img src={img} className={iconClass} alt={`${label} app icon`} />
        <div>
          <div className="Header-logo">{label}</div>
          {!hideDownloadBadge && (
            <a href={storeUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={require("../assets/store.png")}
                style={{ width: 132, height: 39 }}
                alt="Download on the App Store"
              />
            </a>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
